import TRANSLATION_AR from './i18n/locales/ar/translation'
import TRANSLATION_DE from './i18n/locales/de/translation'
import TRANSLATION_EN from './i18n/locales/en/translation'
import TRANSLATION_ES from './i18n/locales/es/translation'
import TRANSLATION_FR from './i18n/locales/fr/translation'
import TRANSLATION_HI from './i18n/locales/hi/translation'
import TRANSLATION_ID from './i18n/locales/id/translation'
import TRANSLATION_IT from './i18n/locales/it/translation'
import TRANSLATION_JA from './i18n/locales/ja/translation'
import TRANSLATION_KO from './i18n/locales/ko/translation'
import TRANSLATION_MA from './i18n/locales/ma/translation'
import TRANSLATION_RU from './i18n/locales/ru/translation'
import TRANSLATION_TH from './i18n/locales/th/translation'
import TRANSLATION_TR from './i18n/locales/tr/translation'
import TRANSLATION_VI from './i18n/locales/vi/translation'
import TRANSLATION_ZH from './i18n/locales/zh/translation'
import TRANSLATION_ZH_HANT from './i18n/locales/zh-Hant/translation'

const combineToMap = (category: Record<string, string>, kv: Array<{ key: string, value: string }>) => {
  return kv.reduce((prev, cur) => {
    prev[cur.value] = category[cur.key]
    return prev
  }, {} as Record<string, string>)
}


/** 广告类型的多语言 */
export const PROJECT_TYPE_MAPS = {
  zh: {
    'Ad Creative Test': '广告创意测试',
    'Ad Creative Selection': '广告创意遴选',
    'Ad Creative Editing': '广告创意剪辑',
  },
  'zh-Hant': {
    'Ad Creative Test': '廣告創意測試',
    'Ad Creative Selection': '廣告創意遴選',
    'Ad Creative Editing': '廣告創意剪輯',
  },
  en: {
    'Ad Creative Test': 'Ad Creative Test',
    'Ad Creative Selection': 'Ad Creative Selection',
    'Ad Creative Editing': 'Ad Creative Editing',
  },
  ja: {
    'Ad Creative Test': '広告クリエイティブテスト',
    'Ad Creative Selection': '広告クリエイティブ選定',
    'Ad Creative Editing': '広告クリエイティブ編集',
  },
  ko: {
    'Ad Creative Test': '광고 크리에이티브 테스트',
    'Ad Creative Selection': '광고 크리에이티브 선택',
    'Ad Creative Editing': '광고 크리에이티브 편집',
  },
  ma: {
    'Ad Creative Test': 'Test créatif publicitaire',
    'Ad Creative Selection': 'Sélection créative publicitaire',
    'Ad Creative Editing': 'Édition créative publicitaire',
  },
  fr: {
    'Ad Creative Test': 'Test créatif publicitaire',
    'Ad Creative Selection': 'Sélection créative publicitaire',
    'Ad Creative Editing': 'Édition créative publicitaire',
  },
  de: {
    'Ad Creative Test': 'Werbungskreativitätstest',
    'Ad Creative Selection': 'Werbungskreativitätsauswahl',
    'Ad Creative Editing': 'Werbungskreativitätsbearbeitung',
  },
  it: {
    'Ad Creative Test': 'Testo creativo pubblicitario',
    'Ad Creative Selection': 'Selezione creatività pubblicitaria',
    'Ad Creative Editing': 'Modifica creatività pubblicitaria',
  },
  es: {
    'Ad Creative Test': 'Prueba creativa publicitaria',
    'Ad Creative Selection': 'Selección creativa publicitaria',
    'Ad Creative Editing': 'Edición creativa publicitaria',
  },
  ru: {
    'Ad Creative Test': 'Тестирование рекламной креативности',
    'Ad Creative Selection': 'Отбор креативов рекламы',
    'Ad Creative Editing': 'Редактирование рекламной креативности',
  },
  ar: {
    'Ad Creative Test': 'اختبار إبداع الإعلان',
    'Ad Creative Selection': 'اختيار إبداعات الإعلان',
    'Ad Creative Editing': 'تحرير إبداعات الإعلان',
  },
  hi: {
    'Ad Creative Test': 'विज्ञापन सृजनात्मकता परीक्षण',
    'Ad Creative Selection': 'विज्ञापन सृजनात्मकताओं का चयन',
    'Ad Creative Editing': 'विज्ञापन सृजनात्मकताओं का संपादन',
  },
  tr: {
    'Ad Creative Test': 'Reklam Yaratıcı Testi',
    'Ad Creative Selection': 'Reklam Yaratıcı Seçimi',
    'Ad Creative Editing': 'Reklam Yaratıcı Düzenleme',
  },
  vi: {
    'Ad Creative Test': 'Kiểm tra sáng tạo quảng cáo',
    'Ad Creative Selection': 'Lựa chọn sáng tạo quảng cáo',
    'Ad Creative Editing': 'Chỉnh sửa sáng tạo quảng cáo',
  },
  id: {
    'Ad Creative Test': 'Uji Kreatif Iklan',
    'Ad Creative Selection': 'Seleksi Kreatif Iklan',
    'Ad Creative Editing': 'Penyuntingan Kreatif Iklan',
  },
  th: {
    'Ad Creative Test': 'การทดสอบความคิดสร้างสรรค์โฆษณา',
    'Ad Creative Selection': 'การคัดเลือกความคิดสร้างสรรค์โฆษณา',
    'Ad Creative Editing': 'การตัดต่อความคิดสร้างสรรค์โฆษณา',
  },
}

/** ----------------------------------目标市场的多语言 ---------------------------------- */
const TARGET_MARKTS_ZH = (TRANSLATION_ZH.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_ZH_HANT = (TRANSLATION_ZH_HANT.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_EN = (TRANSLATION_EN.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_JA = (TRANSLATION_JA.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_KO = (TRANSLATION_KO.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_MA = (TRANSLATION_MA.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_FR = (TRANSLATION_FR.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_DE = (TRANSLATION_DE.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_IT = (TRANSLATION_IT.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_ES = (TRANSLATION_ES.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_RU = (TRANSLATION_RU.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_AR = (TRANSLATION_AR.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_HI = (TRANSLATION_HI.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_TR = (TRANSLATION_TR.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_VI = (TRANSLATION_VI.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_ID = (TRANSLATION_ID.dashboard.projectCreatePage as any).targetMarketSelect
const TARGET_MARKTS_TH = (TRANSLATION_TH.dashboard.projectCreatePage as any).targetMarketSelect

/** 因为后端存储的是行业分类的中文 key */
const TARGET_MARKTS_KV = Object.keys(TARGET_MARKTS_ZH).map((k) => {
  return { key: k, value: TARGET_MARKTS_ZH[k] }
})

export const TARGET_MARKTS_MAPS = {
  zh: combineToMap(TARGET_MARKTS_ZH, TARGET_MARKTS_KV),
  'zh-Hant': combineToMap(TARGET_MARKTS_ZH_HANT, TARGET_MARKTS_KV),
  en: combineToMap(TARGET_MARKTS_EN, TARGET_MARKTS_KV),
  ja: combineToMap(TARGET_MARKTS_JA, TARGET_MARKTS_KV),
  ko: combineToMap(TARGET_MARKTS_KO, TARGET_MARKTS_KV),
  ma: combineToMap(TARGET_MARKTS_MA, TARGET_MARKTS_KV),
  fr: combineToMap(TARGET_MARKTS_FR, TARGET_MARKTS_KV),
  de: combineToMap(TARGET_MARKTS_DE, TARGET_MARKTS_KV),
  it: combineToMap(TARGET_MARKTS_IT, TARGET_MARKTS_KV),
  es: combineToMap(TARGET_MARKTS_ES, TARGET_MARKTS_KV),
  ru: combineToMap(TARGET_MARKTS_RU, TARGET_MARKTS_KV),
  ar: combineToMap(TARGET_MARKTS_AR, TARGET_MARKTS_KV),
  hi: combineToMap(TARGET_MARKTS_HI, TARGET_MARKTS_KV),
  tr: combineToMap(TARGET_MARKTS_TR, TARGET_MARKTS_KV),
  vi: combineToMap(TARGET_MARKTS_VI, TARGET_MARKTS_KV),
  id: combineToMap(TARGET_MARKTS_ID, TARGET_MARKTS_KV),
  th: combineToMap(TARGET_MARKTS_TH, TARGET_MARKTS_KV),
}

/** 性别多语言 */
export const GENDER_MAPS = {
  zh: {
    male: '男',
    female: '女',
    all: '全部',
  },
  'zh-Hant': {
    male: '男',
    female: '女',
    all: '全部',
  },
  en: {
    male: 'Male',
    female: 'Female',
    all: 'All',
  },
  ja: {
    male: '男性',
    female: '女性',
    all: 'すべて',
  },
  ko: {
    male: '남자',
    female: '여자',
    all: '모두',
  },
  ma: {
    male: 'Lelaki',
    female: 'Perempuan',
    all: 'Semua',
  },
  fr: {
    male: 'Homme',
    female: 'Femme',
    all: 'Tous',
  },
  de: {
    male: 'Männlich',
    female: 'Weiblich',
    all: 'Alle',
  },
  it: {
    male: 'Maschile',
    female: 'Femminile',
    all: 'Tutti',
  },
  es: {
    male: 'Masculino',
    female: 'Femenino',
    all: 'Todos',
  },
  ru: {
    male: 'Мужской',
    female: 'Женский',
    all: 'Все',
  },
  ar: {
    male: 'ذكر',
    female: 'أنثى',
    all: 'الكل',
  },
  hi: {
    male: 'पुरुष',
    female: 'महिला',
    all: 'सभी',
  },
  tr: {
    male: 'Erkek',
    female: 'Kadın',
    all: 'Hepsi',
  },
  vi: {
    male: 'Nam',
    female: 'Nữ',
    all: 'Tất cả',
  },
  id: {
    male: 'Pria',
    female: 'Wanita',
    all: 'Semua',
  },
  th: {
    male: 'ชาย',
    female: 'หญิง',
    all: 'ทั้งหมด',
  },
}

/** ----------------------------------行业分类多语言 ---------------------------------- */
const INDUSTRY_CATEGORY_ZH = (TRANSLATION_ZH.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_ZH_HANT = (TRANSLATION_ZH_HANT.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_EN = (TRANSLATION_EN.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_JA = (TRANSLATION_JA.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_KO = (TRANSLATION_KO.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_MA = (TRANSLATION_MA.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_FR = (TRANSLATION_FR.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_DE = (TRANSLATION_DE.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_IT = (TRANSLATION_IT.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_ES = (TRANSLATION_ES.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_RU = (TRANSLATION_RU.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_AR = (TRANSLATION_AR.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_HI = (TRANSLATION_HI.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_TR = (TRANSLATION_TR.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_VI = (TRANSLATION_VI.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_ID = (TRANSLATION_ID.dashboard.projectCreatePage as any).industryCategorySelect
const INDUSTRY_CATEGORY_TH = (TRANSLATION_TH.dashboard.projectCreatePage as any).industryCategorySelect

/** 因为后端存储的是行业分类的中文 key */
const INDUSTRY_CATEGORY_KV = Object.keys(INDUSTRY_CATEGORY_ZH).map((k) => {
  return { key: k, value: INDUSTRY_CATEGORY_ZH[k] }
})
export const INDUSTRY_CATEGORY_MAPS = {
  zh: combineToMap(INDUSTRY_CATEGORY_ZH, INDUSTRY_CATEGORY_KV),
  'zh-Hant': combineToMap(INDUSTRY_CATEGORY_ZH_HANT, INDUSTRY_CATEGORY_KV),
  en: combineToMap(INDUSTRY_CATEGORY_EN, INDUSTRY_CATEGORY_KV),
  ja: combineToMap(INDUSTRY_CATEGORY_JA, INDUSTRY_CATEGORY_KV),
  ko: combineToMap(INDUSTRY_CATEGORY_KO, INDUSTRY_CATEGORY_KV),
  ma: combineToMap(INDUSTRY_CATEGORY_MA, INDUSTRY_CATEGORY_KV),
  fr: combineToMap(INDUSTRY_CATEGORY_FR, INDUSTRY_CATEGORY_KV),
  de: combineToMap(INDUSTRY_CATEGORY_DE, INDUSTRY_CATEGORY_KV),
  it: combineToMap(INDUSTRY_CATEGORY_IT, INDUSTRY_CATEGORY_KV),
  es: combineToMap(INDUSTRY_CATEGORY_ES, INDUSTRY_CATEGORY_KV),
  ru: combineToMap(INDUSTRY_CATEGORY_RU, INDUSTRY_CATEGORY_KV),
  ar: combineToMap(INDUSTRY_CATEGORY_AR, INDUSTRY_CATEGORY_KV),
  hi: combineToMap(INDUSTRY_CATEGORY_HI, INDUSTRY_CATEGORY_KV),
  tr: combineToMap(INDUSTRY_CATEGORY_TR, INDUSTRY_CATEGORY_KV),
  vi: combineToMap(INDUSTRY_CATEGORY_VI, INDUSTRY_CATEGORY_KV),
  id: combineToMap(INDUSTRY_CATEGORY_ID, INDUSTRY_CATEGORY_KV),
  th: combineToMap(INDUSTRY_CATEGORY_TH, INDUSTRY_CATEGORY_KV),
}
